module.exports = __webpack_public_path__ + "img/7.ba96da99.png";